import React from "react";

class ApMobileDisplay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      scale: 0.9,
      position: { x: 0, y: 0 },
      areaAnnotationStart: { x: 0, y: 0 },
      areaAnnotationEnd: { x: 0, y: 0 }
    };
    this.lastPosition = { x: 0, y: 0 };
    this.lastDistance = 0;

    this.refDisplay = React.createRef();
    this.refDisplayMedia = React.createRef();
  }

  reset() {
    if (this.props.addAnnotationMode) return;
    this.setState({ position: { x: 0, y: 0 }, scale: 0.9 });
  }

  touchStart(e) {
    if (this.props.addAnnotationMode) return this.editModeTouchStart(e);

    const touch = e.touches[0];
    this.lastPosition = { x: touch.clientX, y: touch.clientY };

    if (e.touches.length > 1) {
      const a = { x: e.touches[0].clientX, y: e.touches[0].clientY };
      const b = { x: e.touches[1].clientX, y: e.touches[1].clientY };
      this.lastDistance = Math.sqrt(
        Math.pow(a.y - b.y, 2) + Math.pow(a.x - b.x, 2)
      );
    }
  }

  touchMove(e) {
    if (this.props.addAnnotationMode) return this.editModeTouchMove(e);

    if (e.touches.length === 1) {
      //Move
      const touch = e.touches[0];
      const last = this.lastPosition;
      const delta = {
        x: touch.clientX - last.x,
        y: touch.clientY - last.y
      };

      const newPosition = {
        x: this.state.position.x + delta.x,
        y: this.state.position.y + delta.y
      };

      this.setState({
        position: newPosition
      });

      this.lastPosition = { x: touch.clientX, y: touch.clientY };
    } else if (e.touches.length === 2) {
      //Zoom
      const a = { x: e.touches[0].clientX, y: e.touches[0].clientY };
      const b = { x: e.touches[1].clientX, y: e.touches[1].clientY };

      const distance = Math.sqrt(
        Math.pow(a.y - b.y, 2) + Math.pow(a.x - b.x, 2)
      );

      const middle = {
        x: (b.x + a.x) * 0.5,
        y: (b.y + a.y) * 0.5
      };

      const bounds = this.refDisplay.current.getBoundingClientRect();

      const pos = {
        x: (middle.x / bounds.width) * 100,
        y: (middle.y / bounds.height) * 100
      };

      const delta = (distance - this.lastDistance) * 0.01;
      const newScale = this.state.scale + delta;
      if (newScale > 0.2 && newScale < 5)
        this.setState({ scale: newScale, offset: pos });

      this.lastDistance = distance;
    }
  }

  touchEnd(e) {
    if (this.props.addAnnotationMode) return this.editModeTouchEnd(e);
  }

  editModeTouchStart(e) {
    const touch = e.touches[0];
    switch (this.props.addAnnotationType) {
      case "point":
        this.props.onAddAnnotation([this.positionFromTouch(touch)]);
        break;
      case "area":
        this.setState({ areaAnnotationStart: this.positionFromTouch(touch) });
        break;
    }
  }

  editModeTouchMove(e) {
    const touch = e.touches[0];
    switch (this.props.addAnnotationType) {
      case "area":
        this.setState({ areaAnnotationEnd: this.positionFromTouch(touch) });
        break;
    }
  }

  editModeTouchEnd(e) {
    const touch = e.touches[0];
    switch (this.props.addAnnotationType) {
      case "area":
        this.props.onAddAnnotation([
          this.state.areaAnnotationStart,
          this.state.areaAnnotationEnd
        ]);
        this.setState({
          areaAnnotationStart: { x: 0, y: 0 },
          areaAnnotationEnd: { x: 0, y: 0 }
        });
        break;
    }
  }

  positionFromTouch(touch) {
    const bounds = this.refDisplayMedia.current.getBoundingClientRect();

    const x = clamp01((touch.clientX - bounds.x) / bounds.width);
    const y = clamp01((touch.clientY - bounds.y) / bounds.height);

    //Round to 2 decimal places
    return {
      x: Math.floor(x * 10000) / 100,
      y: Math.floor(y * 10000) / 100
    };

    //Helper Function to clamp value between 0 and 1
    function clamp01(value) {
      return Math.min(Math.max(value, 0), 1);
    }
  }

  render() {
    const {
      annotations,
      onHighlightAnnotation,
      highlightedAnnotation,
      rotation,
      page
    } = this.props;
    const {
      position,
      scale,
      areaAnnotationStart,
      areaAnnotationEnd
    } = this.state;

    const posTop = `calc(50% + ${position.y}px)`;
    const posLeft = `calc(50% + ${position.x}px)`;
    const transform = `translate(-50%, -50%) scale(${scale}) rotateZ(${rotation}deg)`;

    let markers = null;
    if (this.refDisplayMedia.current) {
      markers = annotations.map(m => {
        if (m.for.document === page.id) {
          switch (m.marker.type) {
            case "point":
              return (
                <MarkerPoint
                  key={m.id}
                  pos={{
                    x: `${m.marker.position[0].x}%`,
                    y: `${m.marker.position[0].y}%`
                  }}
                  onSelect={() => onHighlightAnnotation(m.id)}
                  ping={highlightedAnnotation === m.id}
                />
              );
            case "area":
              const areaAnnotationStart = m.marker.position[0];
              const areaAnnotationEnd = m.marker.position[1];
              const areaStartX = Math.min(
                areaAnnotationStart.x,
                areaAnnotationEnd.x
              );
              const areaStartY = Math.min(
                areaAnnotationStart.y,
                areaAnnotationEnd.y
              );
              const areaEndX = Math.max(
                areaAnnotationStart.x,
                areaAnnotationEnd.x
              );
              const areaEndY = Math.max(
                areaAnnotationStart.y,
                areaAnnotationEnd.y
              );
              return (
                <MarkerArea
                  key={m.id}
                  pos={{
                    x: `${(areaEndX + areaStartX) * 0.5}%`,
                    y: `${(areaEndY + areaStartY) * 0.5}%`
                  }}
                  size={{
                    x: `${areaEndX - areaStartX}%`,
                    y: `${areaEndY - areaStartY}%`
                  }}
                  onSelect={() => onHighlightAnnotation(m.id)}
                  ping={highlightedAnnotation === m.id}
                />
              );
          }
        }
      });
    }

    const areaStartX = Math.min(areaAnnotationStart.x, areaAnnotationEnd.x);
    const areaStartY = Math.min(areaAnnotationStart.y, areaAnnotationEnd.y);
    const areaEndX = Math.max(areaAnnotationStart.x, areaAnnotationEnd.x);
    const areaEndY = Math.max(areaAnnotationStart.y, areaAnnotationEnd.y);

    return (
      <div className="ApMobileDisplay" ref={this.refDisplay}>
        <p id="ResetBtn" onClick={() => this.reset()}>
          Bild Zentrieren
        </p>

        <div
          id="MediaWrapper"
          style={{
            top: posTop,
            left: posLeft,
            transform: transform
          }}
        >
          {areaAnnotationStart.x !== areaAnnotationEnd.x &&
          areaAnnotationStart.y !== areaAnnotationEnd.y ? (
            <MarkerArea
              pos={{
                x: `${(areaEndX + areaStartX) * 0.5}%`,
                y: `${(areaEndY + areaStartY) * 0.5}%`
              }}
              size={{
                x: `${areaEndX - areaStartX}%`,
                y: `${areaEndY - areaStartY}%`
              }}
              onSelect={() => {}}
              ping={false}
            />
          ) : null}

          {/* Point Markers */ markers}
          <img
            ref={this.refDisplayMedia}
            id="MediaContainer"
            alt="Media"
            src={page.source}
            onTouchStart={e => this.touchStart(e)}
            onTouchMove={e => this.touchMove(e)}
            onTouchEnd={e => this.touchEnd(e)}
          />
        </div>
      </div>
    );
  }
}

function MarkerPoint(props) {
  const classes =
    "ApMobileMarker" + (props.ping ? " ApMobileMarker-Active" : "");
  return (
    <div
      id="Point"
      className={classes}
      onClick={() => props.onSelect()}
      style={{
        left: props.pos.x,
        top: props.pos.y
      }}
    />
  );
}

function MarkerArea(props) {
  const classes =
    "ApMobileMarker" + (props.ping ? " ApMobileMarker-Active" : "");
  return (
    <div
      id="Area"
      className={classes}
      onClick={() => props.onSelect()}
      style={{
        left: props.pos.x,
        top: props.pos.y,
        width: props.size.x,
        height: props.size.y
      }}
    />
  );
}

export default ApMobileDisplay;



// WEBPACK FOOTER //
// ./src/components/approval/mobile/ApMobileDisplay.js